// extracted by mini-css-extract-plugin
export default {"contentContainer":"style_contentContainer__MKXW9","wrap":"style_wrap__HsfU0"};